"use strict";
document.addEventListener("DOMContentLoaded", function () {
	createCustomSelect();
	changeIconSearchInput();
	toggleMobileMenu();
	initAboutIntroSlider();
});
function createCustomSelect() {
	document.querySelectorAll(".custom-select").forEach((select) => {
		const wrapper = select.closest(".wrapper-group-input");
		const label = wrapper.querySelector("label");
		const selected = select.querySelector(".custom-select__selected");
		const optionsContainer = select.querySelector(
			".custom-select__options"
		);
		const options = select.querySelectorAll(".custom-select__option");
		const hiddenInput = select.querySelector('input[type="hidden"]');

		label.addEventListener("click", () => {
			document.querySelectorAll(".custom-select").forEach((s) => {
				if (s !== select) s.classList.remove("active");
			});
			select.classList.toggle("active");
		});

		selected.addEventListener("click", () => {
			document.querySelectorAll(".custom-select").forEach((s) => {
				if (s !== select) s.classList.remove("active");
			});
			select.classList.toggle("active");
		});

		options.forEach((option) => {
			option.addEventListener("click", () => {
				options.forEach((opt) => opt.classList.remove("selected"));
				option.classList.add("selected");

				selected.textContent = option.textContent;
				hiddenInput.value = option.dataset.value;
				selected.classList.add("selected");
				select.classList.remove("active");
			});
		});

		// Закриття при кліку поза селектом
		document.addEventListener("click", (e) => {
			if (!select.contains(e.target) && !label.contains(e.target)) {
				select.classList.remove("active");
			}
		});
	});
}
function changeIconSearchInput() {
	const input = document.querySelector(".input-search");
	const button = document.querySelector(".search__button");
	const icon = button?.querySelector(".icon");

	const updateIcon = () => {
		if (input.value.trim() !== "") {
			icon.classList.remove("icon-i-search");
			icon.classList.add("icon-i-close");
		} else {
			icon.classList.remove("icon-i-close");
			icon.classList.add("icon-i-search");
		}
	};
	if (!input || !button || !icon) {
		console.warn("Search input or button or icon not found");
		return;
	}

	input.addEventListener("input", updateIcon);

	button.addEventListener("click", (e) => {
		e.preventDefault();
		if (icon.classList.contains("icon-i-close")) {
			input.value = "";
			updateIcon();
			input.focus();
		}
	});
}
function toggleMobileMenu() {
	const menuButton = document.querySelector(".btn-mobile-menu");
	const header = document.querySelector(".header");
	const body = document.body;
	menuButton?.addEventListener("click", () => {
		header?.classList.toggle("mobile-menu-open");

		if (header?.classList.contains("mobile-menu-open")) {
			body.classList.add("no-scroll");
		} else {
			body.classList.remove("no-scroll");
		}
	});
}

function initAboutIntroSlider() {
	const slider = document.querySelector(".aboutIntro_blocklist--container");
	const progressBar = document.querySelector(".progress-bar");
	const progressBarLabel = document.querySelector(".slider__label");

	if (!slider) return; // если слайдера нет — выходим

	function updateProgress(slick, index) {
		const calc = ((index + 1) / slick.slideCount) * 100;
		if (progressBar) {
			progressBar.style.width = calc + "%";
		}
		if (progressBarLabel) {
			progressBarLabel.textContent = calc.toFixed(0) + "% completed";
		}
	}

	function initSlider() {
		if (window.innerWidth <= 767) {
			if (!slider.classList.contains("slick-initialized")) {
				$(slider).slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
					dots: false,
					swipe: true,
					draggable: true,
					touchMove: true,
					prevArrow: document.querySelector(".slick-prev-custom"),
					nextArrow: document.querySelector(".slick-next-custom"),
				});

				$(slider).on("beforeChange", function (event, slick, currentSlide, nextSlide) {
					updateProgress(slick, nextSlide);
				});

				updateProgress($(slider).slick("getSlick"), 0);
			}
		} else {
			if (slider.classList.contains("slick-initialized")) {
				$(slider).slick("unslick");
				if (progressBar) progressBar.style.width = "0%";
				if (progressBarLabel) progressBarLabel.textContent = "";
			}
		}
	}

	initSlider();
	window.addEventListener("resize", initSlider);
}